import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContentModalService {
  constructor() {}

  popup2(popupParams: { pageUrl: string; width: number }) {
    (window as any).popup2({
      page_url: popupParams.pageUrl,
      width: popupParams.width,
    });
  }
}
